<template>
    <lost-password
            :resetPassword="resetPassword"
            @loggedIn="$router.push({name: 'dashboard'})"
            @failedToLogin="$store.dispatch('alert/error', $event.data.status)"
    />
</template>
<script>
    import LostPassword from "../../core/Components/User/LostPassword";

    export default {
        components: {
            LostPassword
        },
        methods: {
            resetPassword(data) {
                return this.$store.dispatch('account/lostPassword', data);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/public/LostPassword.vue